import { useState, useEffect } from "react";
import { Link } from "react-router";
import { textQuienesSomos } from "../contentText/quienes-somos-text";

const TEAL = "#4abcc9";
const NAVY = "#0d1f2d";
const NAVY2 = "#1a3a4a";

const { textQuienesSomosDescripcion1, textQuienesSomosDescripcion2, textAcercaDeHeyDocPreguntas } = textQuienesSomos;

const STATS = [
    { number: "+10,000", label: "Consultas respondidas", icon: "forum" },
    { number: "365", label: "Días disponibles al año", icon: "event_available" },
    { number: "100%", label: "Gratuito para ti", icon: "volunteer_activism" },
];

const VALUES = [
    {
        icon: "accessibility_new",
        title: "Accesibilidad",
        desc: "La salud es un derecho. Hacemos que la orientación médica llegue a todos sin costo y sin barreras.",
    },
    {
        icon: "verified",
        title: "Confianza",
        desc: "Médicos cirujanos con cédula profesional verificada responden cada una de tus preguntas.",
    },
    {
        icon: "star",
        title: "Excelencia",
        desc: "Respuestas claras, confiables y oportunas — siempre con el más alto estándar médico.",
    },
    {
        icon: "favorite",
        title: "Calidez",
        desc: "Te escuchamos con empatía. Cada consulta se atiende con el mismo cuidado que mereces.",
    },
];

export default function QuienesSomosPage() {
    const [openIdx, setOpenIdx] = useState<number | null>(null);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <div style={{ fontFamily: "'Manrope', sans-serif", overflowX: "hidden" }}>

            {/* ═══ 1. HERO ═══ */}
            <section style={{
                background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY2} 60%, #0e4a5a 100%)`,
                padding: "56px 24px 48px",
                position: "relative",
                overflow: "hidden",
            }}>
                {/* Dots pattern */}
                <div style={{
                    position: "absolute", inset: 0, opacity: 0.07,
                    backgroundImage: "radial-gradient(circle, #ffffff 1px, transparent 1px)",
                    backgroundSize: "32px 32px",
                }} />
                {/* Glow */}
                <div style={{
                    position: "absolute", right: "-100px", top: "-100px",
                    width: 500, height: 500,
                    background: `radial-gradient(circle, rgba(74,188,201,0.25) 0%, transparent 65%)`,
                    pointerEvents: "none",
                }} />

                <div style={{ maxWidth: 1100, margin: "0 auto", position: "relative", zIndex: 2 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
                        <div style={{ width: 40, height: 3, background: TEAL, borderRadius: 2 }} />
                        <span style={{ color: TEAL, fontFamily: "'Montserrat',sans-serif", fontSize: "0.8rem", fontWeight: 700, letterSpacing: 2, textTransform: "uppercase" }}>
                            Nuestro equipo
                        </span>
                    </div>

                    <div style={{ display: "flex", flexWrap: "wrap", gap: 48, alignItems: "center" }}>
                        <div style={{ flex: "1 1 420px" }}>
                            <h1 style={{
                                fontFamily: "'Montserrat', sans-serif",
                                fontSize: "clamp(2.4rem, 5vw, 4rem)",
                                fontWeight: 900,
                                color: "#ffffff",
                                lineHeight: 1.1,
                                margin: "0 0 24px",
                                letterSpacing: "-1px",
                            }}>
                                Somos el equipo<br />
                                <span style={{ color: TEAL }}>que cuida tu salud</span>
                            </h1>
                            <p style={{
                                fontSize: "1.1rem",
                                fontWeight: 400,
                                color: "rgba(255,255,255,0.75)",
                                lineHeight: 1.7,
                                maxWidth: 520,
                                margin: "0 0 36px",
                            }}>
                                Un equipo interdisciplinario de médicos especialistas comprometidos con hacer la atención médica accesible para todos los mexicanos — sin costo, sin barreras.
                            </p>
                            <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                                <Link to="/" style={{ textDecoration: "none" }}>
                                    <button style={{
                                        background: TEAL, color: "white", border: "none",
                                        padding: "14px 32px", borderRadius: 12,
                                        fontFamily: "'Montserrat', sans-serif",
                                        fontWeight: 700, fontSize: "0.95rem", cursor: "pointer",
                                        transition: "all 0.2s",
                                    }}
                                        onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = "#3daab5"; (e.currentTarget as HTMLElement).style.transform = "translateY(-2px)"; }}
                                        onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = TEAL; (e.currentTarget as HTMLElement).style.transform = "translateY(0)"; }}
                                    >
                                        Inicia tu consulta gratis
                                    </button>
                                </Link>
                            </div>
                        </div>

                        {/* Right side decorative card */}
                        <div style={{ flex: "0 0 auto", display: "flex", gap: 16 }}>
                            <div style={{
                                background: "rgba(255,255,255,0.06)",
                                backdropFilter: "blur(12px)",
                                border: "1px solid rgba(74,188,201,0.25)",
                                borderRadius: 20, padding: "28px 24px",
                                display: "flex", flexDirection: "column", gap: 20,
                                width: 220,
                            }}>
                                {[
                                    { icon: "medical_services", label: "Médicos certificados" },
                                    { icon: "lock", label: "100% confidencial" },
                                    { icon: "bolt", label: "Respuesta inmediata" },
                                ].map(item => (
                                    <div key={item.label} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                        <div style={{ width: 40, height: 40, borderRadius: 10, background: "rgba(74,188,201,0.2)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                            <span className="material-symbols-outlined" style={{ color: TEAL, fontSize: 20 }}>{item.icon}</span>
                                        </div>
                                        <span style={{ color: "rgba(255,255,255,0.85)", fontSize: "0.875rem", fontWeight: 500 }}>{item.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ═══ 3. MISIÓN & VISIÓN ═══ */}
            <section style={{ background: "#f8fbff", padding: "100px 24px" }}>
                <div style={{ maxWidth: 1100, margin: "0 auto" }}>
                    <div style={{ textAlign: "center", marginBottom: 64 }}>
                        <span style={{ display: "inline-block", background: "rgba(74,188,201,0.12)", color: TEAL, fontFamily: "'Montserrat',sans-serif", fontSize: "0.78rem", fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", padding: "6px 16px", borderRadius: 50, marginBottom: 16 }}>
                            Quiénes somos
                        </span>
                        <h2 style={{ fontFamily: "'Montserrat',sans-serif", fontSize: "clamp(1.8rem,4vw,2.8rem)", fontWeight: 800, color: NAVY, margin: "0 0 16px", letterSpacing: "-0.5px" }}>
                            Nuestra misión y visión
                        </h2>
                        <p style={{ color: "#6b7280", fontSize: "1rem", maxWidth: 560, margin: "0 auto" }}>
                            Conoce los principios que guían cada decisión que tomamos en HeyDoctor.
                        </p>
                    </div>

                    <div style={{ display: "flex", flexWrap: "wrap", gap: 28 }}>
                        {[
                            { icon: "rocket_launch", tag: "Misión", color: TEAL, text: textQuienesSomosDescripcion1 },
                            { icon: "visibility", tag: "Visión", color: "#7c3aed", text: textQuienesSomosDescripcion2 },
                        ].map(item => (
                            <div key={item.tag} style={{
                                flex: "1 1 420px",
                                background: "white",
                                borderRadius: 20,
                                padding: "40px 36px",
                                border: "1.5px solid #f0f4f8",
                                boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
                                position: "relative",
                                overflow: "hidden",
                            }}>
                                <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 4, background: item.color, borderRadius: "20px 20px 0 0" }} />
                                <div style={{ width: 56, height: 56, borderRadius: 14, background: `${item.color}18`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
                                    <span className="material-symbols-outlined" style={{ fontSize: 28, color: item.color }}>{item.icon}</span>
                                </div>
                                <div style={{ display: "inline-block", background: `${item.color}18`, color: item.color, fontFamily: "'Montserrat',sans-serif", fontSize: "0.75rem", fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase", padding: "4px 12px", borderRadius: 50, marginBottom: 16 }}>
                                    {item.tag}
                                </div>
                                <p style={{ color: "#4b5563", fontSize: "1rem", lineHeight: 1.75, margin: 0 }}>
                                    {item.text}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ═══ 4. VALORES ═══ */}
            <section style={{ background: "white", padding: "100px 24px" }}>
                <div style={{ maxWidth: 1100, margin: "0 auto" }}>
                    <div style={{ textAlign: "center", marginBottom: 64 }}>
                        <span style={{ display: "inline-block", background: "rgba(74,188,201,0.12)", color: TEAL, fontFamily: "'Montserrat',sans-serif", fontSize: "0.78rem", fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", padding: "6px 16px", borderRadius: 50, marginBottom: 16 }}>
                            Lo que nos define
                        </span>
                        <h2 style={{ fontFamily: "'Montserrat',sans-serif", fontSize: "clamp(1.8rem,4vw,2.8rem)", fontWeight: 800, color: NAVY, margin: 0, letterSpacing: "-0.5px" }}>
                            Nuestros valores
                        </h2>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 24 }}>
                        {VALUES.map((v, i) => (
                            <div key={v.title} style={{
                                background: i % 2 === 0 ? "#f8fbff" : "white",
                                border: "1.5px solid #eef2f7",
                                borderRadius: 20,
                                padding: "36px 28px",
                                transition: "all 0.25s",
                                cursor: "default",
                                position: "relative",
                                overflow: "hidden",
                            }}
                                onMouseEnter={e => {
                                    const el = e.currentTarget as HTMLElement;
                                    el.style.transform = "translateY(-4px)";
                                    el.style.boxShadow = "0 12px 32px rgba(74,188,201,0.15)";
                                    el.style.borderColor = TEAL;
                                }}
                                onMouseLeave={e => {
                                    const el = e.currentTarget as HTMLElement;
                                    el.style.transform = "translateY(0)";
                                    el.style.boxShadow = "none";
                                    el.style.borderColor = "#eef2f7";
                                }}
                            >
                                {/* Big background number */}
                                <div style={{ position: "absolute", right: 16, top: 8, fontFamily: "'Montserrat',sans-serif", fontSize: "5rem", fontWeight: 900, color: "rgba(74,188,201,0.07)", lineHeight: 1 }}>
                                    0{i + 1}
                                </div>
                                <div style={{ width: 52, height: 52, borderRadius: 14, background: "rgba(74,188,201,0.12)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
                                    <span className="material-symbols-outlined" style={{ fontSize: 26, color: TEAL }}>{v.icon}</span>
                                </div>
                                <h3 style={{ fontFamily: "'Montserrat',sans-serif", fontSize: "1.15rem", fontWeight: 700, color: NAVY, margin: "0 0 12px" }}>{v.title}</h3>
                                <p style={{ color: "#6b7280", fontSize: "0.9rem", lineHeight: 1.65, margin: 0 }}>{v.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ═══ 5. FAQ ═══ */}
            <section style={{ background: "#f8fbff", padding: "100px 24px" }}>
                <div style={{ maxWidth: 800, margin: "0 auto" }}>
                    <div style={{ textAlign: "center", marginBottom: 56 }}>
                        <span style={{ display: "inline-block", background: "rgba(74,188,201,0.12)", color: TEAL, fontFamily: "'Montserrat',sans-serif", fontSize: "0.78rem", fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", padding: "6px 16px", borderRadius: 50, marginBottom: 16 }}>
                            Preguntas frecuentes
                        </span>
                        <h2 style={{ fontFamily: "'Montserrat',sans-serif", fontSize: "clamp(1.8rem,4vw,2.6rem)", fontWeight: 800, color: NAVY, margin: "0 0 12px", letterSpacing: "-0.5px" }}>
                            Acerca de HeyDoctor
                        </h2>
                        <p style={{ color: "#6b7280", fontSize: "1rem" }}>
                            ¿Tienes dudas sobre cómo funciona nuestra plataforma? Encuentra aquí las respuestas.
                        </p>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                        {textAcercaDeHeyDocPreguntas.map((q, i) => {
                            const isOpen = openIdx === i;
                            return (
                                <div key={i} style={{
                                    background: "white",
                                    border: `1.5px solid ${isOpen ? TEAL : "#eef2f7"}`,
                                    borderRadius: 14,
                                    overflow: "hidden",
                                    transition: "border-color 0.2s",
                                    boxShadow: isOpen ? "0 4px 20px rgba(74,188,201,0.12)" : "none",
                                }}>
                                    <button
                                        onClick={() => setOpenIdx(isOpen ? null : i)}
                                        style={{
                                            width: "100%",
                                            background: "none",
                                            border: "none",
                                            padding: "20px 24px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            cursor: "pointer",
                                            gap: 16,
                                        }}
                                    >
                                        <span style={{ fontFamily: "'Montserrat',sans-serif", fontWeight: 600, fontSize: "0.95rem", color: isOpen ? TEAL : NAVY, textAlign: "left" }}>
                                            {q.textPregunta}
                                        </span>
                                        <span style={{ flexShrink: 0, width: 28, height: 28, borderRadius: "50%", background: isOpen ? TEAL : "#f0f4f8", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s" }}>
                                            <span className="material-symbols-outlined" style={{ fontSize: 18, color: isOpen ? "white" : "#9ca3af", transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s", display: "block" }}>
                                                expand_more
                                            </span>
                                        </span>
                                    </button>
                                    {isOpen && (
                                        <div style={{ padding: "0 24px 20px", borderTop: "1px solid #f0f4f8" }}>
                                            <p style={{ color: "#4b5563", fontSize: "0.95rem", lineHeight: 1.7, margin: "16px 0 0" }}>
                                                {q.textRespuesta}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

        </div>
    );
}
